module.exports = __webpack_public_path__ + "img/cart4.505a641c.svg";